import { createApi } from '@reduxjs/toolkit/query/react';

import { AuthorityCreateDto, AuthorityUpdateDto, AuthorityViewDto } from '../common/dto/authority.dto';
import { DeleteParamsDto, DeleteStatusDto, PaginatedResponse } from '../common/dto/common.dto';
import { FilterDto } from '../common/dto/filter.dto';
import customFetchBase from './base.service';

const API_URI = import.meta.env.VITE_CORE_SERVICE;
const TAG_TYPE = 'User';

export const authorityApi = createApi({
  reducerPath: 'authorityApi',
  baseQuery: customFetchBase(`${API_URI}/api/authority`),
  tagTypes: [TAG_TYPE],
  endpoints: (builder) => ({
    searchAuthority: builder.mutation<PaginatedResponse<AuthorityViewDto>, Partial<FilterDto>>({
      query(body) {
        return {
          url: ``,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    getAuthority: builder.query<AuthorityViewDto, string>({
      query: (id: string) => {
        return `/${id}`;
      },
      providesTags: [TAG_TYPE],
    }),
    updateAuthority: builder.mutation<AuthorityViewDto, Partial<AuthorityUpdateDto>>({
      query(data) {
        return {
          url: ``,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    addAuthority: builder.mutation<AuthorityViewDto, Partial<AuthorityCreateDto>>({
      query(body) {
        return {
          url: ``,
          method: 'POST',
          body,
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
    deleteAuthority: builder.mutation<DeleteStatusDto, DeleteParamsDto>({
      query(data: DeleteParamsDto) {
        return {
          url: data.id,
          method: 'DELETE',
          body: data.params ?? {},
        };
      },
      invalidatesTags: [TAG_TYPE],
    }),
  }),
});

// auto-generated based on the defined endpoints
export const { useSearchAuthorityMutation, useGetAuthorityQuery, useUpdateAuthorityMutation, useAddAuthorityMutation, useDeleteAuthorityMutation } =
  authorityApi;
